<template>
  <div class="box5">
    <pageTitle
      title="高技能傍身 岗位选择范围大"
      text="软件测试就业方向众多，有了高技能的加持，就业当然稳稳地"
      titColor="#86909C"
    />

    <div class="subject-box">
      <div class="box-inner">
        <div class="left">
          <span>自动化测试工程师</span>
          <span>游戏测试工程师</span>
          <span>移动端测试工程师</span>
          <span>性能测试工程师</span>
          <span>接口测试工程师</span>
        </div>
        <div class="right">
          <span>测试开发工程师</span>
          <span>Web端测试工程师</span>
          <span>鸿蒙测试工程师</span>
          <span>安全测试工程师</span>
          <span>车载测试工程师</span>
        </div>
      </div>
    </div>
    <a class="btn" @click="zixun('不同技能的软件测试薪资水平')">不同技能的软件测试薪资水平</a>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      list: [
        {
          img: require("../../../assets/coursePage/softwareTest/box3/01.png"),
        },
        {
          img: require("../../../assets/coursePage/softwareTest/box3/02.png"),
        },
      ],

      cur: 0,
      swiperOption: {
        loop: true, // 循环模式选项
        slidesPerView: "auto",
        spaceBetween: 40,
        slidesPerView: "auto",
        centeredSlides: true,
        pagination: {
          el: ".swiper-pagination-box2",
        },
      },
    };
  },
  methods: {
    zixun() {
      this.mai("软件测试-就业课","不同技能的软件测试薪资水平",0,null)
      this.clickZiXun()
    },
  },
};
</script>

<style lang="less" scoped>
.box5 {
  padding: 80px 32px 88px;
  box-sizing: border-box;
  width: 100%;
  background: url("../../../assets/coursePage/softwareTest/box5/bg.png")
    no-repeat;
  background-size: 100% 100%;
  background-origin: center;

  .subject-box {
    margin: 48px auto 0;
    position: relative;

    // padding-bottom: 22px;
    width: 100%;

    border-radius: 20px;

    .box-inner {
      display: flex;
      justify-content: center;
      align-items: flex-start;
    }
    span {
      display: block;

      box-sizing: border-box;

      text-align: center;
      margin-bottom: 24px;
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #4e5969;

      height: 76px;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 312px;
      height: 76px;
      background: linear-gradient( 180deg, #DDEDFF 0%, #F5FAFF 100%);
      box-shadow: 0px 8px 24px 0px rgba(64,128,255,0.12);
      border-radius: 16px;
      border: 2px solid #ffffff;
      box-sizing: border-box;
    }
    span.last {
      width: 646px;
      height: 76px;
      background: rgba(255, 255, 255, 0.5);
      box-shadow: 0px 8px 24px 0px rgba(64, 128, 255, 0.12);
      border-radius: 16px;
      border: 2px solid #ffffff;
      margin: 0 auto;
    }
    .left {
      margin-right: 22px;
    }
  }
  .btn {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 96px;
    text-align: center;
    width: 686px;
    height: 96px;
    background: linear-gradient(224deg, #37abff 0%, #3d8efd 100%);
    border-radius: 48px;
    display: block;
    margin-top: 40px;
  }
}
</style>
